import { Col, Row, Skeleton, Card } from "antd";
import React, { useEffect, useState } from "react";
import { isCompanyUser, useLoginContext } from "contexts/LoginContext/LoginContext";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { Company } from "interfaces/company";
import dayjs from "dayjs";
import { message } from "components/Messages/Messages";
import { StarOutlined, StarFilled } from "@ant-design/icons";
import { FavoriteJob, Job } from "interfaces/jobs";
import CompanyLogo from "components/CompanyLogo/CompanyLogo";
import { StyledText, StyledTitle } from "./style";
import RibbonStatusBadge from "./RibbonStatusBadge/RibbonStatusBadge";

interface Props {
  job: Job;
}

const SingleJobPostingBox: React.FC<Props> = ({ job }) => {
  const [company, setCompany] = useState<Company>();
  const [favoriteJobs, setFavoriteJobs] = useState<FavoriteJob[]>([]);

  useEffect(
    function getCompany() {
      axios.get(`/companies/${job.company}/`).then(response => setCompany(response.data));
    },
    [job.company]
  );

  const { currentUser } = useLoginContext();
  const history = useHistory();

  useEffect(() => {
    if (!currentUser || isCompanyUser(currentUser)) return;
    axios.get<FavoriteJob[]>("/jobs/favorites/").then(response => {
      setFavoriteJobs(response.data);
    });
  }, [currentUser]);

  const handleFavorite = () => {
    if (!currentUser || isCompanyUser(currentUser)) return;
    axios.get<FavoriteJob[]>("/jobs/favorites/").then(response => {
      setFavoriteJobs(response.data);
    });
  };

  const createFavJob = () => {
    axios
      .post<FavoriteJob>("/jobs/favorites/", {
        student: currentUser?.id,
        job: job.id,
      })
      .then(() => {
        message(
          "success",
          "Stillingsannonse lagt til i favoritter",
          'Du kan se en oversikt over dine favoritter under "Min profil"'
        );
        handleFavorite();
      })
      .catch(() => message("error", "Kunne ikke legge til stillingsannonse i favoritter"));
  };

  const delFavJob = (jobId: number | undefined) => {
    const favId = favoriteJobs.find(fav => fav.job === jobId)?.id;
    axios
      .delete<FavoriteJob>(`/jobs/favorites/${favId}/`)
      .then(() => {
        message("success", "Stillingsannonse fjernet fra favoritter");
        handleFavorite();
      })
      .catch(() => message("error", "Kunne ikke fjerne stillingsannonse fra favoritter"));
  };

  return (
    <>
      <RibbonStatusBadge deadline={job.deadline} created_at={job.created_at}>
        <Card
          hoverable
          bodyStyle={{ padding: "0.5em", paddingLeft: "0.8em" }}
          onClick={() => history.push(`/jobs/${job.id}/`)}
        >
          <Row>
            <Col span={4}>
              {company ? <CompanyLogo size="100%" companyId={job.company} src={company.logo} /> : <Skeleton.Image />}
            </Col>
            <Col
              span={17}
              style={{ paddingLeft: "1em", lineHeight: "100%", paddingTop: "0.5em", paddingBottom: "0.5em" }}
            >
              <Row>
                <StyledText>{company ? company.name : <Skeleton.Button active style={{ height: "1em" }} />}</StyledText>
              </Row>
              <Row>
                <StyledTitle level={4}>{job.title}</StyledTitle>
              </Row>
              <Row style={{ color: "#808080" }}>Søknadsfrist: {dayjs(job.deadline).format("DD.MM.YYYY")}</Row>
            </Col>
            <Col span={3} style={{ alignItems: "center", justifyContent: "center", display: "flex" }}>
              <div style={{ textAlign: "center", lineHeight: "100%" }}>
                {currentUser && !isCompanyUser(currentUser) ? (
                  favoriteJobs.some(fav => fav.job === job.id) ? (
                    <StarFilled
                      style={{ color: "#f3922d", fontSize: "1.7em", zIndex: 100 }}
                      onClick={e => {
                        e.stopPropagation(); // This prevents the card link. Only remove favorite.
                        delFavJob(job.id);
                      }}
                    />
                  ) : (
                    <StarOutlined
                      style={{ color: "#f3922d", fontSize: "1.7em" }}
                      onClick={e => {
                        e.stopPropagation(); // This prevents the card link. Only add favorite.
                        createFavJob();
                      }}
                    />
                  )
                ) : null}
              </div>
            </Col>
          </Row>
        </Card>
      </RibbonStatusBadge>
    </>
  );
};

export default SingleJobPostingBox;
